require('./hireCardMaestroStep2.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
import { DisclaimerPersonalInfo } from 'components/hire/cardViaT/disclaimerPersonalInfo/disclaimerPersonalInfo';
const HireCardNameSelector = require('components/hire/hireCardNameSelector/hireCardNameSelector');

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

//@ utilities
const { hasAllAccountsInactive } = require('utilities/currentAccountsHelper');

// @ constants
const { SECOND_STEP } = require('constants/index');

class hireCardMaestroStep2 extends React.Component {

    componentDidMount(){
        const {
            immAccounts,
            setAllAccountsToInactive,
            accountsIndexesFiltered,
        } = this.props;

        const allAccountsInactive = hasAllAccountsInactive(accountsIndexesFiltered, immAccounts.get('byId'));
        if(allAccountsInactive) {
            setAllAccountsToInactive();
        }
    }

    render() {
        const {
            accountsIndexesFiltered,
            handleAccountChange,
            immAccounts,
            immHireCardNameSelector,
            immHireCardMaestro,
            isInactiveAccountsEnabled,
            contracts,
        } = this.props;
        const immStep2 = immHireCardMaestro.getIn(['steps', SECOND_STEP], '');
        const accountErrorMsgVisible = immStep2.get('accountIsDirty') && !immStep2.get('accountId');
        const accountErrorMsg = formatText('hireCardMaestro-step2SelectAccountError');
        const accountLabel = formatText('hireCardMaestro-step2SelectAccount');
        const disclaimerPersonalInfoUrl = contracts && contracts.get('proteccion_datos', '') || '';
        const tooltipMsgContent = isInactiveAccountsEnabled ? 'inactiveAccounts-inactiveAccounts_dropdownCommonToolTip' : '';

        return (
            <article className="hire-card-maestro-step-two">
                <FormattedText
                    className="hire-card-maestro__step-title"
                    value="hireCardMaestro-step2Title"
                />
                <HireCardNameSelector
                    immHireCardNameSelector={immHireCardNameSelector}
                />
                <DropdownAccounts
                    accountsIndexes={accountsIndexesFiltered}
                    currentAccountId={immStep2.get('accountId')}
                    error={accountErrorMsgVisible}
                    errorMsg={accountErrorMsg}
                    immAccounts={immAccounts.get('byId')}
                    label={accountLabel}
                    onAccountChange={handleAccountChange}
                    optionalElement={DisclaimerPersonalInfo()}
                    showAvailableBalance
                    showInactiveAccountsAsBlocked={isInactiveAccountsEnabled}
                    tooltipMsg={tooltipMsgContent}
                />
                <div className="hire-card-maestro-step-two__disclaimer-personal-info">
                    <OKMessage type="informative">
                        <FormattedText value="disclaimerPersonalInfo-MaestroMsg" />
                        &nbsp;
                        <OKLink modifier="emphasize" to={disclaimerPersonalInfoUrl} target="_blank">
                            <FormattedText value="disclaimerPersonalInfo-MaestroLinkText" />
                        </OKLink>
                    </OKMessage>
                </div>
            </article>
        );
    }
}

hireCardMaestroStep2.propTypes = {
    accountsIndexesFiltered: PropTypes.object.isRequired,
    handleAccountChange: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardMaestro: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    setAllAccountsToInactive: PropTypes.func.isRequired,
    contracts: PropTypes.object.isRequired
};

module.exports = hireCardMaestroStep2;
